import React from 'react'

import FundDetail from '../../../templates/FundDetail'
import './style.scss'

const TWFundDetail = () => {
  return <FundDetail />
}

export default TWFundDetail
